import { render, staticRenderFns } from "./vacancy-application-tab.vue?vue&type=template&id=1452725e"
import script from "./vacancy-application-tab.vue?vue&type=script&lang=js"
export * from "./vacancy-application-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports